import React, { createContext, useState } from 'react'

export const loginUserId = createContext()

export default function LoginUserIdContext(props) {
  const [id, setId] = useState()
  const value = { id, setId }
  return (
    <loginUserId.Provider value={value}>
      {props.children}
    </loginUserId.Provider>
  )
}
